function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SpendOutputTemplate = require('./spend-output.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../unlock_tx_edit'),
  addSaitoOutput = _require2.addSaitoOutput,
  addNftOutput = _require2.addNftOutput,
  formatNolanAmount = _require2.formatNolanAmount,
  parsePositiveSaitoAmount = _require2.parsePositiveSaitoAmount,
  remainingSaitoNolan = _require2.remainingSaitoNolan;

/**
 * Create an output on unlock_transaction_base from a selected input.
 */
var SpendOutputFlow = /*#__PURE__*/function () {
  function SpendOutputFlow(app, mod, mainUi) {
    var _this = this;
    _classCallCheck(this, SpendOutputFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.step = null;
    this.kind = null;
    this.inputIndex = 0;
    this.availableNolan = BigInt(0);
    this.availableDisplay = '';
    this.blockedRoot = null;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.step) {
        _this.hide();
      }
    };
  }
  return _createClass(SpendOutputFlow, [{
    key: "openForInput",
    value: function openForInput() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$kind = _ref.kind,
        kind = _ref$kind === void 0 ? 'saito' : _ref$kind,
        _ref$inputIndex = _ref.inputIndex,
        inputIndex = _ref$inputIndex === void 0 ? 0 : _ref$inputIndex;
      var _require3 = require('../unlock_tx_fee'),
        isUnlockEditable = _require3.isUnlockEditable,
        UNLOCK_SIGNED_ERROR = _require3.UNLOCK_SIGNED_ERROR;
      if (!isUnlockEditable(this.mod)) {
        window.alert(UNLOCK_SIGNED_ERROR);
        return;
      }
      this.kind = kind === 'nft' ? 'nft' : 'saito';
      this.inputIndex = Number(inputIndex) || 0;
      this.step = this.kind;
      if (this.kind === 'nft') {
        this.availableNolan = BigInt(0);
        this.availableDisplay = '';
        this.show(SpendOutputTemplate.transferNftOverlay());
        this.bindNftEvents();
        return;
      }
      this.availableNolan = remainingSaitoNolan(this.mod);
      this.availableDisplay = "".concat(formatNolanAmount(this.app, this.availableNolan), " SAITO");
      this.show(SpendOutputTemplate.spendSaitoOverlay({
        availableDisplay: this.availableDisplay
      }));
      this.bindSaitoEvents();
    }
  }, {
    key: "show",
    value: function show(html) {
      var _this2 = this;
      document.body.classList.add('rs-publish-modal-open');
      this.blockedRoot = document.querySelector('main.rustscript');
      if (this.blockedRoot) {
        this.blockedRoot.inert = true;
      }
      document.addEventListener('keydown', this.onEscapeKey);
      this.overlay.show(html, function () {
        _this2.onOverlayClosed();
      });
      applyPublishOverlayShell(this.overlay);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.step) {
        this.overlay.close();
      }
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      var _this$mainUi, _this$mainUi$clearUnl;
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      if (this.blockedRoot) {
        this.blockedRoot.inert = false;
        this.blockedRoot = null;
      }
      this.step = null;
      this.kind = null;
      this.availableNolan = BigInt(0);
      this.availableDisplay = '';
      (_this$mainUi = this.mainUi) === null || _this$mainUi === void 0 || (_this$mainUi$clearUnl = _this$mainUi.clearUnlockInputSelection) === null || _this$mainUi$clearUnl === void 0 || _this$mainUi$clearUnl.call(_this$mainUi);
    }
  }, {
    key: "fillMyPublicKey",
    value: function () {
      var _fillMyPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(inputEl, showError) {
        var _this$app$wallet, _this$app$wallet2, pk, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              pk = '';
              if (!(typeof ((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.getPublicKey) === 'function')) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.app.wallet.getPublicKey();
            case 1:
              pk = _context.v;
              _context.n = 3;
              break;
            case 2:
              if (typeof ((_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 ? void 0 : _this$app$wallet2.returnPublicKey) === 'function') {
                pk = this.app.wallet.returnPublicKey();
              }
            case 3:
              if (pk) {
                _context.n = 4;
                break;
              }
              showError('Could not read your public key.');
              return _context.a(2);
            case 4:
              inputEl.value = String(pk);
              showError('');
              inputEl.focus({
                preventScroll: true
              });
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              showError('Could not read your public key.');
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function fillMyPublicKey(_x, _x2) {
        return _fillMyPublicKey.apply(this, arguments);
      }
      return fillMyPublicKey;
    }()
  }, {
    key: "validateSaitoAmount",
    value: function validateSaitoAmount(amountRaw, showError) {
      var amount = parsePositiveSaitoAmount(amountRaw);
      if (amount === null) {
        showError('Enter a valid amount.');
        return null;
      }
      var amountNolan;
      try {
        amountNolan = this.app.wallet.convertSaitoToNolan(amount);
      } catch (_err) {
        showError('Enter a valid amount.');
        return null;
      }
      if (amountNolan <= BigInt(0)) {
        showError('Enter an amount greater than zero.');
        return null;
      }
      if (amountNolan > this.availableNolan) {
        showError("Only ".concat(this.availableDisplay, " available."));
        return null;
      }
      showError('');
      return amount;
    }
  }, {
    key: "bindSaitoEvents",
    value: function bindSaitoEvents() {
      var _root$querySelector,
        _this3 = this,
        _root$querySelector2,
        _root$querySelector3;
      var root = document.querySelector('.rs-spend-saito');
      if (!root) {
        return;
      }
      var errorEl = root.querySelector('.rs-spend-error');
      var recipientInput = root.querySelector('.rs-spend-recipient');
      var amountInput = root.querySelector('.rs-spend-amount');
      var showError = function showError(msg) {
        if (!errorEl) {
          return;
        }
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      };
      (_root$querySelector = root.querySelector('.rs-spend-use-mine')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        if (recipientInput) {
          _this3.fillMyPublicKey(recipientInput, showError);
        }
      });
      (_root$querySelector2 = root.querySelector('[data-action="spend-max"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function () {
        if (!amountInput) {
          return;
        }
        amountInput.value = formatNolanAmount(_this3.app, _this3.availableNolan);
        _this3.validateSaitoAmount(amountInput.value, showError);
        amountInput.focus({
          preventScroll: true
        });
      });
      amountInput === null || amountInput === void 0 || amountInput.addEventListener('input', function () {
        var raw = String(amountInput.value || '').trim();
        if (!raw) {
          showError('');
          return;
        }
        _this3.validateSaitoAmount(raw, showError);
      });
      (_root$querySelector3 = root.querySelector('[data-action="create-output"]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', function () {
        var _recipientInput$value;
        showError('');
        var recipient = (recipientInput === null || recipientInput === void 0 || (_recipientInput$value = recipientInput.value) === null || _recipientInput$value === void 0 ? void 0 : _recipientInput$value.trim()) || '';
        var amount = _this3.validateSaitoAmount(amountInput === null || amountInput === void 0 ? void 0 : amountInput.value, showError);
        if (!recipient || !_this3.app.crypto.isPublicKey(recipient)) {
          showError('Enter a valid recipient address.');
          return;
        }
        if (amount === null) {
          return;
        }
        try {
          var _this3$mainUi, _this3$mainUi$refresh;
          // Prefer exact nolan when the field matches MAX / full remaining display.
          // SAITO string round-trips can leave 1-nolan dust and hide the broadcast button.
          var typed = String((amountInput === null || amountInput === void 0 ? void 0 : amountInput.value) || '').trim();
          var maxDisplay = formatNolanAmount(_this3.app, _this3.availableNolan);
          var useExact = typed === maxDisplay || _this3.app.wallet.convertSaitoToNolan(amount) >= _this3.availableNolan;
          addSaitoOutput(_this3.app, _this3.mod, useExact ? {
            recipient: recipient,
            amountNolan: _this3.availableNolan
          } : {
            recipient: recipient,
            amountSaito: amount
          }, _this3.mainUi);
          _this3.hide();
          (_this3$mainUi = _this3.mainUi) === null || _this3$mainUi === void 0 || (_this3$mainUi$refresh = _this3$mainUi.refresh) === null || _this3$mainUi$refresh === void 0 || _this3$mainUi$refresh.call(_this3$mainUi, {
            skipTestSync: true
          });
        } catch (err) {
          showError((err === null || err === void 0 ? void 0 : err.message) || 'Could not create output.');
        }
      });
      recipientInput === null || recipientInput === void 0 || recipientInput.focus({
        preventScroll: true
      });
    }
  }, {
    key: "bindNftEvents",
    value: function bindNftEvents() {
      var _root$querySelector4,
        _this4 = this,
        _root$querySelector5;
      var root = document.querySelector('.rs-spend-nft');
      if (!root) {
        return;
      }
      var errorEl = root.querySelector('.rs-spend-error');
      var recipientInput = root.querySelector('.rs-spend-recipient');
      var showError = function showError(msg) {
        if (!errorEl) {
          return;
        }
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      };
      (_root$querySelector4 = root.querySelector('.rs-spend-use-mine')) === null || _root$querySelector4 === void 0 || _root$querySelector4.addEventListener('click', function () {
        if (recipientInput) {
          _this4.fillMyPublicKey(recipientInput, showError);
        }
      });
      (_root$querySelector5 = root.querySelector('[data-action="transfer-nft"]')) === null || _root$querySelector5 === void 0 || _root$querySelector5.addEventListener('click', function () {
        var _recipientInput$value2;
        showError('');
        var recipient = (recipientInput === null || recipientInput === void 0 || (_recipientInput$value2 = recipientInput.value) === null || _recipientInput$value2 === void 0 ? void 0 : _recipientInput$value2.trim()) || '';
        if (!recipient || !_this4.app.crypto.isPublicKey(recipient)) {
          showError('Enter a valid recipient address.');
          return;
        }
        try {
          var _this4$mainUi, _this4$mainUi$refresh;
          addNftOutput(_this4.app, _this4.mod, {
            recipient: recipient
          }, _this4.mainUi);
          _this4.hide();
          (_this4$mainUi = _this4.mainUi) === null || _this4$mainUi === void 0 || (_this4$mainUi$refresh = _this4$mainUi.refresh) === null || _this4$mainUi$refresh === void 0 || _this4$mainUi$refresh.call(_this4$mainUi, {
            skipTestSync: true
          });
        } catch (err) {
          showError((err === null || err === void 0 ? void 0 : err.message) || 'Could not transfer NFT.');
        }
      });
      recipientInput === null || recipientInput === void 0 || recipientInput.focus({
        preventScroll: true
      });
    }
  }]);
}();
module.exports = SpendOutputFlow;